module.exports = __webpack_public_path__ + "static/media/carta_53.0546f259.jpg";